export default "__VITE_ASSET__oS1WuCAm__";